import styled from 'styled-components';

import { Text, Skeleton, Icon } from '@gympass/yoga';
import { Info } from '@gympass/yoga-icons';

import { ItemType } from './types';

export const SessionsContainer = styled.div<ItemType>`
  display: flex;
  align-items: center;
  padding-top: ${({ largeItem, theme }) =>
    largeItem ? '0' : theme.yoga.spacing.medium}px;
  padding-bottom: ${({ largeItem, theme }) =>
    largeItem ? theme.yoga.spacing.small : theme.yoga.spacing.medium}px;
  border-bottom: ${({ theme }) =>
    `${theme.yoga.borders.small}px solid ${theme.yoga.colors.separatorBackground}`};
`;

export const IconsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${({ theme }) => theme.yoga.spacing.small}px;
  min-width: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
  height: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
  border-radius: ${({ theme }) => theme.yoga.radii.circle}px;
  background-color: ${({ theme }) => theme.yoga.colors.primary};
`;

export const TooltipContainer = styled.div`
  margin-left: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
`;

export const StyledInfo = styled(Info)`
  height: ${({ theme }) => theme.yoga.spacing.xsmall}px;
  width: ${({ theme }) => theme.yoga.spacing.xsmall}px;
  fill: ${({ theme }) => theme.yoga.colors.inputDisabled};
`;

export const SessionTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const SessionTextSubContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SessionsSubTitle = styled(Text.Small)`
  color: ${({ theme }) => theme.yoga.colors.deep};
`;

export const SessionsSmall = styled(Text.H4)`
  color: ${({ theme }) => theme.yoga.colors.stamina};
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
`;

export const SessionsLarge = styled(Text.H2)`
  color: ${({ theme }) => theme.yoga.colors.stamina};
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
`;

export const FieldSkeleton = styled(Skeleton).attrs({
  width: 0,
  height: 0,
  type: 'rectangular',
})`
  width: ${({ theme }) => theme.yoga.sizes.noProgramWidth}px;
  height: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const StyledIcon = styled(Icon)`
  height: ${({ theme }) => theme.yoga.spacing.large}px;
  width: ${({ theme }) => theme.yoga.spacing.large}px;
  fill: ${({ theme }) => theme.yoga.colors.white};
`;

export const LabelText = styled(Text.Tiny)`
  color: ${({ theme }) => theme.yoga.colors.text.secondary};
`;
